"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var unread_request_store_1 = require("~/stores/users/estimates/requests/unread_request_store");
var Alert = function (props) {
    var alertConfig = props.alertConfig;
    var messageClassName = (0, classnames_1.default)("unreadRequestWindow-Alert_Message", {
        "unreadRequestWindow-Alert_Message-info": alertConfig.type === unread_request_store_1.AlertMessageType.INFO,
        "unreadRequestWindow-Alert_Message-error": alertConfig.type === unread_request_store_1.AlertMessageType.ERROR
    });
    return (react_1.default.createElement("div", { className: "unreadRequestWindow-Alert_BackGround" },
        react_1.default.createElement("div", { className: messageClassName }, alertConfig.message)));
};
exports.default = Alert;
